import './layout.css'

function MenuTab({title, menuItems, selected}) {
    return (
        <div className='menu-tab'>
            <p className='menu-tab-title'>{title}</p>
            {selected && (
                <ul className='menu-tab-list'>
                    {menuItems && menuItems.map(
                        (item, index) => {
                            return (
                                <li key={index} className='menu-tab-item'>
                                    <a className={item.href === window.location.pathname ? 'menu-tab-link-active' : 'menu-tab-link'} href={item.href}>{item.item}</a>
                                </li>
                            )
                        }
                    )}
                </ul>
            )}
        </div>
    )
}

export default MenuTab